import Crud from '../components/Ticket/Crud'
import Ticket from '../components/Ticket/Ticket'

let routes = {
    path: '/tickets',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/tickets',
          name: 'Chamados',
          component: Crud
      },
      {
        path: '/ticket/:id?',
        name: 'Chamado',
        component: Ticket
    }
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/tickets.js